import fileContributionResource from "@/shared/resource/filecontribution";
import { authorizedAxios } from "./authorizedAxios";
import {
  HoldOverAmountSummary,
  SftpVendorTypeOption,
  SftpVendorResponse,
  SftpMapping
} from "@/shared/types";
import {
  ContributionUploadedFile,
  ContributionUploadedFileDetails,
  PendingContributionReport,
  FileCancelResponse,
  CancelContributionHoldsRequest,
  FileProcessorSettingsRequest,
  FileProcessSettingsResponse,
  FundingFileSummaryResponse,
  FileUploadRequest,
  PriorYearInfoResponse,
  NextYearProcessDateInfoResponse
} from "@/employer/types";

export function uploadFundingFile (request: FileUploadRequest, employerId: number) {
  const params: any = {};

  if (request.effectiveYear) {
    params.effectiveYear = request.effectiveYear;
  }

  return authorizedAxios.postFiles(fileContributionResource.uploadFundingFile(employerId), [request.file], params);
}

export function getPriorYearInfo (employerId: number) {
  return authorizedAxios.get<PriorYearInfoResponse>(fileContributionResource.priorYear(employerId));
}

export function getNextYearProcessDateInfo (employerId: number) {
  return authorizedAxios.get<NextYearProcessDateInfoResponse>(fileContributionResource.nextYearProcessDate(employerId));
}

export function getEmployerContributionFiles (employerId: number, pageNumber: number, pageSize: number, sortOrder: string) {
  return authorizedAxios.get<FundingFileSummaryResponse>(fileContributionResource
      .getEmployerContributionFileInfo(employerId, pageNumber, pageSize, sortOrder));
}

export function getEmployerContributionFileDetails (employerId: number, id: number) {
  return authorizedAxios.get<ContributionUploadedFileDetails>(
    fileContributionResource.getEmployerContributionsDetails(employerId, id));
}

export function getSftpVendorType (employerId: number) {
  return authorizedAxios
    .get<SftpVendorResponse>(fileContributionResource.employerSftpVendorType(employerId));
}

export function putSftpVendorType (employerId: number, sftpVendorType: SftpVendorTypeOption) {
  return authorizedAxios
    .post<any>(fileContributionResource.employerSftpVendorType(employerId), {sftpVendorType});
}

export function addSftpMapping (employerId: number, sftpMapCode: string) {
  return authorizedAxios
    .post<SftpMapping>(fileContributionResource.employerSftpMap(employerId), { sftpMapCode });
}

export function deleteSftpMapping (employerId: number, sftpMapId: number) {
  return authorizedAxios
    .delete<SftpVendorResponse>(fileContributionResource.employerSftpMapDelete(employerId, sftpMapId));
}

export function downloadFundingFileSummary (employerId: number, id: number) {
  return authorizedAxios
    .get(fileContributionResource.downloadFundingFileSummary(employerId, id));
}

export function cancelFundingFileProcess (employerId: number, id: number) {
  return authorizedAxios
    .put<FileCancelResponse>(fileContributionResource.cancelFundingFileProcess(employerId, id));
}

export function cancelContributionHolds (employerId: number, request: CancelContributionHoldsRequest) {
  return authorizedAxios
    .post<boolean>(fileContributionResource.cancelContributionHolds(employerId), request);
}

export function getPendingContributionsReport (employerId: number, pageNumber: number,
  pageSize: number, getPendingContributionsReport: boolean) {
  return authorizedAxios
    .get<PendingContributionReport>(fileContributionResource.getPendingContributionsReport(
      employerId, pageNumber, pageSize, getPendingContributionsReport));
}

export function getPendingContributionsReportDownload (employerId: number, displayExpiredContributionsOnly: boolean) {
  return authorizedAxios
    .get<PendingContributionReport>(fileContributionResource
      .getPendingContributionsReportDownload(employerId, displayExpiredContributionsOnly));
}

export function downloadEmployeeProcessedHoldOverReport (employerId: number, payrollDate: string) {
  return authorizedAxios
    .get(fileContributionResource.getEmployeeProcessedHoldOverReportDownload(employerId, payrollDate));
}

export function getProcessedHoldOverAmountsByPayDates (employerId: number, payrollDates: string []) {
  return authorizedAxios
    .post<HoldOverAmountSummary>(fileContributionResource.getProcessedHoldOverAmountByPayrolldates(employerId), payrollDates);
}

export function getFileProcessorSettings (employerId: number) {
  return authorizedAxios
    .get(fileContributionResource.fileProcessorSettings(employerId));
}

export function saveFileProcessorSettings (employerId: number, sftpSetting: FileProcessorSettingsRequest) {
  return authorizedAxios
    .post<FileProcessSettingsResponse>(fileContributionResource.fileProcessorSettings(employerId), sftpSetting);
}
